<script>
import Footer from "./Footer.svelte";
import Home from "./home/Home.svelte";
</script>

<Home />

<Footer />
